import cookieUtil from '../cookieUtil';

const setToken = (token: string, refreshToken: string) => {
  cookieUtil.setCookie('token', token, 60 * 60 * 24 * 7);
  if (refreshToken) cookieUtil.setCookie('refreshToken', refreshToken, 60 * 60 * 24 * 7);
};

export default setToken;
